import React, {Component} from 'react';
import {withRouteData} from 'react-static';
import TypedJS from 'typed.js';

class Typed extends Component {
	componentDidMount() {
		const { strings, typeSpeed, backSpeed, backDelay, loop } = this.props;
		const options = {
			strings,
			typeSpeed: typeSpeed || 50,
			backSpeed: backSpeed || 50,
			backDelay: backDelay || 0,
			loop: loop || false
		};
		this.typed = new TypedJS(this.el, options);
	}

	componentWillUnmount() {
		this.typed.destroy();
	}

	render() {
		return (
				<span className={this.props.className}>
          <span
	          style={{ whiteSpace: 'pre' }}
	          ref={(el) => { this.el = el; }}
          />
				</span>
		);
	}
}

export default withRouteData(Typed)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/Typed.js